import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Fingerprint } from "lucide-react";
import { Header } from "@/components/Header";
import { TermSheetVerificationCard } from "@/components/housing/TermSheetVerificationCard";
import { TermSheetQRCode } from "@/components/housing/TermSheetQRCode";
import { isDigest } from "@/lib/termSheetHasher";
import { useLang } from "@/context/LangContext";
import { vtx } from "@/lib/verifyI18n";

export default function DigestVerify() {
  const { digest } = useParams(); const nav = useNavigate(); const [input, setInput] = useState(digest || "");
  const ok = isDigest(digest); const { lang } = useLang(); const t = vtx(lang);
  return (
    <div className="min-h-screen bg-[#050A15] text-slate-200" data-testid="digest-verify-page">
      <Header />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-10 space-y-4">
        <p className="text-[10px] uppercase tracking-widest text-[#00FFFF] flex items-center gap-1"><Fingerprint className="h-3 w-3" /> {t.d_eyebrow}</p>
        <h1 className="font-display text-3xl sm:text-4xl">{t.d_title}</h1>
        <p className="text-sm text-slate-400">{t.d_intro}</p>
        <form className="flex flex-wrap gap-2 text-xs" onSubmit={(e) => { e.preventDefault(); if (isDigest(input.trim())) nav(`/verify/${input.trim().toLowerCase()}`); }}>
          <input data-testid="digest-input" value={input} onChange={(e) => setInput(e.target.value)} placeholder={t.d_placeholder} className="bg-black/40 border border-white/10 px-2 py-1 text-slate-100 flex-1 min-w-[280px] font-mono" />
          <button data-testid="digest-submit" className="border border-[#00FFFF]/50 text-[#00FFFF] px-3 py-1">{t.d_verify}</button>
        </form>
        {!ok && <p role="alert" data-testid="digest-invalid" className="text-sm text-red-300">“{digest}” {t.d_invalid}</p>}
        {ok && <div className="grid md:grid-cols-[1fr_auto] gap-4 items-start"><TermSheetVerificationCard digest={digest.toLowerCase()} /><TermSheetQRCode url={window.location.href} size={120} fileName={`verify-${digest.slice(2, 10)}`} /></div>}
      </main>
    </div>
  );
}
